import React from "react";
import {connect} from "react-redux";

class buttonComponent extends React.Component {
    constructor(props) {
        super ( props );
        this.state = {
            lang : this.props.lang,
            color : "",
            backgroundColor:""
        };
        this.onDown = this.onDown.bind(this);
        this.onUp = this.onUp.bind(this);
    }
    onDown() {
        this.setState({color : "#ed2939"});
        this.setState({backgroundColor : "white"});
    }
    onUp(e) {
        e.target.style.removeProperty('background-color');
        e.target.style.removeProperty('color');
    }
    render() {
        return (

            <button
                style={{color : this.state.color, backgroundColor : this.state.backgroundColor}}
                className={this.props.class}
                type={this.props.type}
                onMouseDown={this.onDown}
                onMouseUp={(e)=>{this.onUp(e)}}
                onClick={this.props.onClick}
            >{this.props.text}</button>
        )
    }
}

const mapStateToProps = (state) => {
    return ({
        lang : state ? state.lang : '' ,
    });
};

export const Button = connect ( mapStateToProps ) ( buttonComponent );